import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import { ChangeEventHandler, Fragment, useState } from 'react';
import { Button, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { UPLOAD_URL } from '../constants';
import { IProduct } from '../products';
import { emptyPerson, Person } from '../types';
import { CaptchaButton } from './CaptchaButton';

export interface SendGiftModalProps {
    toggleModal: () => void,
    selectedProduct: IProduct
}
export default function SendGiftForm(props: SendGiftModalProps) {

    const [message, setMessage] = useState("");
    const [selectedFile, setSelectedFile] = useState<File>();
    const [people, setPeople] = useState<Person[]>([emptyPerson])
    const [loading, setLoading] = useState<boolean>(false)
    const removePerson = (index: number) => {
        if (index <= 0) return;
        setPeople(people.filter((p, i) => i !== index))
    }

    const addPerson = () => {
        if (people.length < 6) {
            setPeople([...people, emptyPerson])
        }
    }

    const updatePerson = (index: number, email: string, firstname: string, lastname: string, phone: string) => {
        const newState = people.map((p, i) => {
            if (i === index) {
                return {
                    email: email,
                    firstname: firstname,
                    lastname: lastname,
                    phone: phone
                }
            } else {
                return p
            }
        })
        setPeople(newState)
    }

    const submitForm = (token: string) => {
        const formData = new FormData();
        for (let i = 0; i < people.length; i++) {
            const p = people[i]
            if(i === 0 && p.email.trim() === ""){
                alert("Por favor agregá tu email para que te podamos agradecer")
                return
            }
            if(p.firstname.trim() === "") {
                alert("Falta un nombre")
                return
            }
            if(p.lastname.trim() === "") {
                alert("Falta un apellido")
                return
            }
        }

        if(token === "" || token === undefined) {
            alert("Something went wrong.")
            return
        }

        if(selectedFile === undefined) {
            alert("Por favor, agregá el comprobante de transferencia");
            return
            
        } else {
            if (selectedFile.size > (1024 * 5 * 1000)) {    
                alert("El archivo no puede superar los 5MB");
                setSelectedFile(undefined)
                return
            }
            formData.append("img", selectedFile)
        }
        if (message === undefined || message.trim() === ""){
            alert("Por favor agrega un mensaje de no más de 1000 caracteres")
            return
        }
        formData.append("who", JSON.stringify(people))
        formData.append("message", message)
        formData.append("id", props.selectedProduct.id + "")
        formData.append("g-recaptcha-response", token)
        console.log(formData)
        setLoading(true)
        axios
            .post(UPLOAD_URL, formData)
            .then((res) => {
                console.log(res)
                setMessage("")
                setPeople([emptyPerson])
                setSelectedFile(undefined)
                setLoading(false)
                props.toggleModal()
                alert("¡Muchas gracias!");
            })
            .catch((err) => {
                console.error(err)
                setLoading(false)
                alert("Hubo un error")
            });

    };


    const handleFileInput: ChangeEventHandler<HTMLInputElement> = (e) => {
        // handle validations
        if (e.target.files && e.target.files?.length > 0) {
            const file = e.target.files[0];
            if (file.size > (1024 * 5 * 1000)) {
                setSelectedFile(undefined)
                alert("El archivo no puede superar los 5MB");
            } else {
                setSelectedFile(file);
            }
        } else {
            setSelectedFile(undefined)
        }
    };
    return (
        <Fragment>
            <Row>
                <Form>
                    <Label>Dejanos un mensaje para que te podamos agradecer:</Label>
                    <FormGroup>
                        <Label>Mensaje:</Label>
                        <Input value={message} type="textarea" rows="4" maxLength={1024} onChange={e => setMessage(e.target.value)}/>
                    </FormGroup>
                    <Label>Este regalo es de parte de:</Label>
                    <FormGroup>
                        {people.map((p, index) => {
                            return (<div className='product-modal-row' key={index}>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col sm={10}><Label for={"email-" + index}>Email:</Label>
                                            </Col>
                                            <Col sm={2}>
                                                {index !== 0 ? <Button color='danger' size='sm' onClick={() => removePerson(index)}><FontAwesomeIcon icon={faTrash}/>Quitar</Button> : <Fragment />}
                                            </Col>
                                        </Row>
                                        <Input required={index === 0} value={p.email} type="email" name={"email-" + index} id={"email-" + index} placeholder="Email"
                                            onChange={(v) => { updatePerson(index, v.target.value, p.firstname, p.lastname, p.phone) }} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col sm={10}><Label for={"phone-" + index}>Teléfono:</Label>
                                            </Col>
                                            <Col sm={2}>
                                                {index !== 0 ? <Button color='danger' size='sm' onClick={() => removePerson(index)}><FontAwesomeIcon icon={faTrash}/>Quitar</Button> : <Fragment />}
                                            </Col>
                                        </Row>
                                        <Input required={index === 0} value={p.phone} type="tel" name={"phone-" + index} id={"phone-" + index} placeholder="Teléfono"
                                            onChange={(v) => { updatePerson(index, p.email, p.firstname, p.lastname, v.target.value) }} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <Label for={"firstname-" + index}>Nombre:</Label>
                                        <Input required value={p.firstname} type="text" name={"firstname-" + index} id={"firstname-" + index} placeholder="Nombre"
                                            onChange={(v) => { updatePerson(index, p.email, v.target.value, p.lastname, p.phone) }} />
                                    </Col>
                                    <Col md={6}>
                                        <Label for={"lastname-" + index}>Apellido:</Label>
                                        <Input required value={p.lastname} type="text" name={"lastname-" + index} id={"lastname-" + index} placeholder="Apellido"
                                            onChange={(v) => { updatePerson(index, p.email, p.firstname, v.target.value, p.phone) }} />
                                    </Col>
                                </Row>
                            </div>)
                        })}
                    </FormGroup>
                    {people.length < 6 ? <Fragment>
                        <Button color='info' size='m' onClick={() => addPerson()}><FontAwesomeIcon icon={faPlus}/> Regalar en conjunto</Button>
                    </Fragment> : <Fragment />}
                    <FormGroup>
                        <Label>Comprobante de transferencia/depósito:</Label>
                        <Input required type='file' label='Upload' accept='image/*' onChange={handleFileInput} />
                    </FormGroup>
                </Form>
            </Row>
            <Row>
                <CaptchaButton disabled={loading} onSumbit={submitForm} />
            </Row>
        </Fragment>)

}

